import {jwtDecode} from "jwt-decode";

export const isAuthenticated = () => {
    if(typeof window == "undefined"){
        return false;
    }
    if(localStorage.getItem('authToken')){
        try {
            const token = JSON.parse(localStorage.getItem('authToken'));
            // Verify token hasn't expired
            const decoded = jwtDecode(token);
            if (decoded.exp * 1000 < Date.now()) {
                localStorage.removeItem('authToken');
                return false;
            }
            return token;
        } catch (error) {
            console.error('Auth token validation error:', error);
            return false;
        }
    }
    return false;
}   

export const getMyId = () => {
    try {
        const authToken = localStorage.getItem("authToken");
        if (!authToken) return null;

        const token = JSON.parse(authToken);
        const decoded = jwtDecode(token);
        return decoded.user_id;
    } catch (error) {
        console.error('Error getting user ID:', error);
        return null;
    }
}

export const authenticate = (authToken, next) => {
    if(typeof window !== "undefined"){
        try {
            // Verify the token is valid before storing
            const decoded = jwtDecode(authToken);
            if (decoded && decoded.user_id) {
                localStorage.setItem("authToken", JSON.stringify(authToken));
                next();
            } else {
                throw new Error('Invalid token format');
            }
        } catch (error) {
            console.error('Authentication error:', error);
            // Don't store invalid tokens
            localStorage.removeItem("authToken");
            next(error);
        }
    }
}

export const logout = (next) => {
    localStorage.clear();
    next();
}
